import { getFingerprint, getIsUserLogged, getUser } from '../selectors/users';

import { useAppSelector } from './redux';

export const useUser = () => useAppSelector(getUser);
export const useIsUserLogged = () => useAppSelector(getIsUserLogged);
export const useFingerprint = () => useAppSelector(getFingerprint);
